import { CheckCircleIcon, CheckIcon } from "@heroicons/react/24/outline";
import { ResumeStatus, Status } from "./constants";

interface StatusTrackerProps {
  currentStage: Status;
}

export default function StatusTracker({ currentStage }: StatusTrackerProps) {
  function isStatusCompleted(
    currentStage: Status,
    targetStatus: Status
  ): boolean {
    const currentIndex = ResumeStatus.findIndex(
      (s) => s.status === currentStage
    );
    const targetIndex = ResumeStatus.findIndex(
      (s) => s.status === targetStatus
    );

    // Check if the current stage has passed or is at the target stage
    return currentIndex >= targetIndex;
  }
  return (
    <div className="relative">
      {/* Vertical line */}
      <div className="absolute bottom-0 left-4 top-0 w-0.5 bg-gray-200" />

      {ResumeStatus.slice(1).map((stage, index) => {
        const isCompleted = isStatusCompleted(currentStage, stage.status);
        const isActive = stage.status === currentStage;

        return (
          <div
            key={stage.status}
            className="relative mb-8 flex items-center last:mb-0"
          >
            <div
              className={`
              absolute left-0 z-10 flex h-8 w-8 items-center justify-center rounded-full border-2
              ${
                isCompleted
                  ? "border-green-500 bg-green-500"
                  : "border-gray-300 bg-white"
              }
              ${isActive ? "ring-4 ring-green-100" : ""}
            `}
            >
              {isCompleted ? (
                <CheckCircleIcon className="h-5 w-5 text-white" />
              ) : (
                <CheckIcon className="h-5 w-5 text-gray-300" />
              )}
            </div>
            <div className="ml-12">
              <h3
                className={`text-sm font-semibold md:text-lg ${
                  isCompleted ? "text-green-500" : "text-gray-700"
                }`}
              >
                {stage.name}
              </h3>
              <p
                className={`text-[10px] md:text-sm ${
                  isCompleted ? "text-green-600" : "text-gray-500"
                }`}
              >
                {stage.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
